import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { post } from '../http';
import { activeSnack } from './common';

// import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const getAllCronJobs = createAsyncThunk(
  'cronjob/list',
  async ({ page, search, dispatch, date, limit, state }) => {
    try {
      const response = await post(
        `/cronjob/admin/all?search=${search && search}&from=${date?.from || ''}&to=${
          date?.to || ''
        }&page=${page && page}&limit=${limit || 5}`,
        state
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const CronJobSlice = createSlice({
  name: 'cron-jobs',
  initialState: {
    loading: false,
    error: {},
    // staff
    cronJobs: {},
    referralMembers: {},
    clubIncomeTransactions: {},
    memberDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllCronJobs.pending]: (state) => {
      state.loading = true;
    },
    [getAllCronJobs.fulfilled]: (state, action) => {
      state.loading = false;
      state.cronJobs = action.payload;
      state.error = {};
    },
    [getAllCronJobs.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = CronJobSlice.actions;

export default CronJobSlice.reducer;
